import { useState, useEffect } from 'react';

/**
 * Custom hook to detect if the device is mobile or has touch capability
 * @returns {boolean} - true if mobile/touch device, false otherwise
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check for touch capability
    const checkIfMobile = () => {
      const hasTouchScreen = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
      
      // Also check for mobile viewport width
      const isMobileWidth = window.innerWidth <= 768;
      
      // Consider it mobile if it has touch or is narrow screen
      setIsMobile(hasTouchScreen || isMobileWidth);
    };

    // Initial check
    checkIfMobile();

    // Add resize listener to detect orientation changes or responsive testing
    const handleResize = () => {
      checkIfMobile();
    };

    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;